import {
  Button,
  Col,
  Descriptions,
  Divider,
  Icons,
  PageHeader,
  Table,
  Row,
  DateField,
  CreateButton,
  useModalForm,
  Collapse,
  Typography,
  Tag,
} from '@pankod/refine-antd'
import { useList, useMany, useShow, useTable } from '@pankod/refine-core'
import { IPaperTemplate, IPaperTemplateSubSection, IProduct, ISection, ISubject, ITestEvent, ITestTrack } from 'interfaces'
import { useEffect, useState } from 'react'
import { TableColumnsType } from 'antd'
const { Text, Link } = Typography
const { Panel } = Collapse
export const PaperTemplateShow = () => {
  const [testEventData, setTestEventData] = useState<any[]>([])

  const { queryResult } = useShow<IPaperTemplate>({
    resource: 'paper_templates',

    metaData: {
      fields: [
        'id',
        'name',
        'description',
        'status',
        'sections',
        'is_completed',
        { test_tracks: ['name'] },
        { product: ['name'] },
        {
          paper_template: [
            'name',
            'mark_per_question',
            'no_of_questions',
            'section_id',
            'base_lang',
            'target_lang',
            { report_theme: ['name'] },
            { subject: ['name'] },
            { theme: ['name'] },
            { sub_theme: ['name'] },
            { topic: ['name'] },
            { question_type: ['name', 'id'] },
            { bloom_level: ['name'] },
            { difficulty_level: ['name'] },
            { competency: ['name'] },
            { strand: ['name'] },
          ],
        },
      ],
    },
  })

  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data
  console.log(record,"Record")
  const { tableQueryResult: sectionQueryResult, setFilters: sectionFilters } = useTable<ISection>({
    resource: 'sections',
    metaData: {
      fields: ['id', 'name'],
    },
  })
  useEffect(() => {
    if (record && record?.paper_template?.length > 0) {
      record?.paper_template?.sort((a: any, b: any) => parseFloat(a.name) - parseFloat(b.name))
    }
  }, [record?.paper_template])
  useEffect(() => {
    let arr: string[] = []
    record?.sections?.map((item: any) => {
      if (!arr.includes(item)) arr.push(item)
    })

    if (arr.length > 0) {
      sectionFilters([
        {
          field: 'id',
          operator: 'in',
          value: arr,
        },
      ])
    }
  }, [queryResult?.data?.data])

  return (
    <>
      <PageHeader
        className="site-page-header-responsive"
        ghost={false}
        title={`${record?.name} `}
        extra={[
          <>
            <Button key="close" onClick={() => window.history.back()} icon={<Icons.LeftOutlined />}>
              Back
            </Button>
            ,
          </>,
        ]}
      >
        <Descriptions size="small" column={3}>
          <Descriptions.Item label="">
            {<Tag color={record?.is_completed ? 'green' : 'blue'}>{record?.is_completed ? 'Completed' : 'In Progress'}</Tag>}
          </Descriptions.Item>
        </Descriptions>
        <Descriptions size="small" column={2}>
          <Descriptions.Item label="Product Name">{record?.product?.name}</Descriptions.Item>
          <Descriptions.Item label="Test Track">{record?.test_tracks?.name}</Descriptions.Item>
          {/* <Descriptions.Item label="Location">{record?.location}</Descriptions.Item>
          <Descriptions.Item label="Mode Of Exam">{record?.mode_of_exam}</Descriptions.Item> */}
        </Descriptions>
        <Descriptions size="small" column={1}>
          <Descriptions.Item label="Description">{record?.description}</Descriptions.Item>
        </Descriptions>

        <Divider style={{ margin: ' 0', paddingBottom: 15 }} />
        {JSON.stringify(record?.paper_template) !== '{}' ? (
          <>
            <b style={{ marginBottom: 15 }}>Sub Section Details</b>
            <div style={{ height: 15 }}></div>
            <Collapse defaultActiveKey={['1']}>
              {sectionQueryResult?.data?.data?.map(item => (
                <Panel header={item?.name} key={item?.id}>
                  <Row gutter={[16, 0]} style={{ height: 40, background: '#f8f8fb', alignItems: 'center' }}>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Name
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Subject
                      </Typography.Text>
                    </Col>
                    {/* <Col lg={3}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }}>Report Theme</Typography.Text>
                    </Col> */}
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Theme
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Sub Theme
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Topic
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Report Theme
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Blooms
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Difficulty
                      </Typography.Text>
                    </Col>
                    {/* ---- */}
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Competency
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        strand
                      </Typography.Text>
                    </Col>
                    {/* ----- */}
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Type
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Count
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        MPQ
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        B L
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        T L
                      </Typography.Text>
                    </Col>
                  </Row>
                  {JSON.stringify(record?.paper_template) !== '{}'
                    ? record?.paper_template?.map((subsection: any, index: any) =>
                        subsection?.section_id === item?.id ? (
                          <Row gutter={[16, 0]} style={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            <>
                              <>
                                <Col xs={24} lg={2}>
                                  <Typography.Text>{subsection?.name}</Typography.Text>
                                </Col>
                                <Col xs={24} lg={2}>
                                  <Typography.Text>{subsection?.subject?.name}</Typography.Text>
                                </Col>
                                {/* <Col xs={24} lg={3}>
                                  <Typography.Text>{subsection?.report_theme?.name}</Typography.Text>
                                </Col> */}
                                <Col xs={24} lg={2}>
                                  <Typography.Text ellipsis={true}>{subsection?.theme?.name}</Typography.Text>
                                </Col>
                                <Col xs={24} lg={2}>
                                  <Typography.Text ellipsis={true}>{subsection?.sub_theme?.name}</Typography.Text>
                                </Col>
                                <Col xs={24} lg={2}>
                                  <Typography.Text ellipsis={true}>{subsection?.topic?.name}</Typography.Text>
                                </Col>
                                <Col xs={24} lg={2}>
                                  <Typography.Text ellipsis={true}>{subsection?.report_theme?.name}</Typography.Text>
                                </Col>
                                <Col xs={24} lg={2}>
                                  <Typography.Text ellipsis={true}>{subsection?.bloom_level?.name}</Typography.Text>
                                </Col>
                                <Col xs={24} lg={2}>
                                  <Typography.Text ellipsis={true}>{subsection?.difficulty_level?.name}</Typography.Text>
                                </Col>
                                {/* -- */}
                                <Col xs={24} lg={1}>
                                  <Typography.Text ellipsis={true}>{subsection?.competency?.name}</Typography.Text>
                                </Col>
                                <Col xs={24} lg={2}>
                                  <Typography.Text ellipsis={true}>{subsection?.strand?.name}</Typography.Text>
                                </Col>
                                {/* --- */}
                                <Col xs={24} lg={1}>
                                  <Typography.Text ellipsis={true}>{subsection?.question_type?.id}</Typography.Text>
                                </Col>

                                <Col xs={24} lg={1}>
                                  <Typography.Text strong>{subsection?.no_of_questions}</Typography.Text>
                                </Col>
                                <Col xs={24} lg={1}>
                                  <Typography.Text strong>{subsection?.mark_per_question}</Typography.Text>
                                </Col>
                                <Col xs={24} lg={1}>
                                  <Typography.Text strong ellipsis>{subsection?.base_lang}</Typography.Text>
                                </Col>
                                <Col xs={24} lg={1}>
                                  <Typography.Text strong ellipsis>{subsection?.target_lang}</Typography.Text>
                                </Col>
                              </>
                            </>
                          </Row>
                        ) : null
                      )
                    : null}
                </Panel>
              ))}
            </Collapse>
            {/* <Table size="small" columns={columns} dataSource={record?.paper_template} pagination={false} /> */}
          </>
        ) : null}
      </PageHeader>
    </>
  )
}
